export const GET_UNREAD_COUNT = 'GET_UNREAD_COUNT';
export const GET_UNREAD_COUNT_SUCCESS = 'GET_UNREAD_COUNT_SUCCESS';
export const GET_UNREAD_COUNT_ERROR = 'GET_UNREAD_COUNT_ERROR';

export interface GetUnreadCount {
  type: typeof GET_UNREAD_COUNT;
  payload: null;
}

export interface GetUnreadCountSuccess {
  type: typeof GET_UNREAD_COUNT_SUCCESS;
  payload: number;
}

export interface GetUnreadCountError {
  type: typeof GET_UNREAD_COUNT_ERROR;
  payload: string | boolean;
}

export interface State {
  data: number;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: 0,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = GetUnreadCount | GetUnreadCountSuccess | GetUnreadCountError;
